import {
  sortBy, propOr
} from 'ramda';

const sortRequirements = sortBy(propOr('sortOrder', 'listNumber'));

export default sortRequirements;
